module.exports = __webpack_public_path__ + "img/9blue.2723bf2f.png";